export const URL_ORQUESTRADOR = process.env.REACT_APP_URL_ORQUESTRADOR;
export const GC_FRONT_END_V1 = process.env.REACT_APP_GC_FRONT_END_V1;
export const GC_BACKEND = process.env.REACT_APP_GC_BACKEND;
export const URL_SIRENS = process.env.REACT_APP_URL_SIRENS;
export const BASE_BUCKET_AWS = process.env.REACT_APP_BASE_BUCKET_AWS;

export const SHOW_BANNER_RELEASE_V1 = process.env.REACT_APP_SHOW_BANNER_RELEASE_V1;
export const BANNER_TYPE_PRE_RELEASE_V1 = process.env.REACT_APP_BANNER_TYPE_PRE_RELEASE_V1;
export const DIA_BANNER_RELEASE_V1 = process.env.REACT_APP_DIA_BANNER_RELEASE_V1;
export const MES_BANNER_RELEASE_V1 = process.env.REACT_APP_MES_BANNER_RELEASE_V1;
export const URL_BANNER_RELEASE_V1 = process.env.REACT_APP_URL_BANNER_RELEASE_V1;
export const REACT_APP_MINUTOS_VENCIMENTO_BANNER_PROMOCIONAL_PAY_V1 = process.env.REACT_APP_MINUTOS_VENCIMENTO_BANNER_PROMOCIONAL_PAY_V1;